'use client';

import React__default from 'react';
import Col from '../../../LayoutSystem/Col.js';
import Row from '../../../LayoutSystem/Row.js';
import { ImgContainer, Image } from '../../styles.css.js';
import { useOnBoarding } from '../../context/index.js';
import { useTranslate } from '../../../Contexts/translator/index.js';
import Button from '../../../Button/index.js';
import { Title } from '../Title.js';
import { getCookie, setCookie } from '../../../Utils/cookie.js';
import { VNW_NEW_REGISTERED } from '../../const.js';

var Successfully = function () {
    var t = useTranslate().t;
    var _a = useOnBoarding(), baseImageUrl = _a.baseImageUrl, baseUrl = _a.baseUrl;
    return (React__default.createElement(Col, null,
        React__default.createElement(Row, { gutter: [16, 0], justify: 'center', style: { marginTop: 50 } },
            React__default.createElement(Col, { xs: 24, md: 16 },
                React__default.createElement(Row, null,
                    React__default.createElement(Col, null,
                        React__default.createElement(ImgContainer, { width: '423px', height: '318px' },
                            React__default.createElement(Image, { src: "".concat(baseImageUrl, "/onboarding/create-profile-success.png"), alt: 'logo vietnamworks.com', title: 'vietnamworks.com' }))),
                    React__default.createElement(Col, null,
                        React__default.createElement(Title, { title: t("You've successfully set up your profile"), subTitle: t('Congratulations! Your profile is good to go. Start your journey towards your dream job and connect with potential employers.') })))),
            React__default.createElement(Col, { xs: 24, md: 16 },
                React__default.createElement(Button, { type: 'primary', size: 'lg', style: { width: '100% ' }, onClick: function () {
                        var VNW_NEW_REGISTERED_COOKIES = getCookie(VNW_NEW_REGISTERED);
                        if (VNW_NEW_REGISTERED_COOKIES) {
                            setCookie(VNW_NEW_REGISTERED, 'false', -1);
                        }
                        window.location.assign("".concat(baseUrl, "/").concat(t('my-profile')));
                    } }, t('View my profile'))))));
};

export { Successfully as default };
//# sourceMappingURL=index.js.map
